import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useNotifications } from '@/contexts/NotificationsContext';
import { Home, Search, Bell, User } from 'lucide-react';

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { unreadCount } = useNotifications();

  if (!user) return null;

  const tabs = [
    { icon: Home, label: 'Feed', href: '/feed' },
    { icon: Search, label: 'Search', href: '/search' },
    { icon: Bell, label: 'Notifications', href: '/notifications', badge: unreadCount },
    { icon: User, label: 'Profile', href: `/profile/${user.username}` },
  ];

  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-cream border-t border-cream-dark md:hidden">
      <div className="flex items-center">
        {tabs.map(({ icon: Icon, label, href, badge }) => {
          const active = location.pathname === href || (href !== '/feed' && location.pathname.startsWith(href));
          return (
            <button
              key={href}
              onClick={() => navigate(href)}
              className={`flex-1 flex flex-col items-center gap-0.5 py-2.5 transition-colors relative ${
                active ? 'text-terra' : 'text-ink-muted hover:text-ink'
              }`}
              aria-label={label}
            >
              <div className="relative">
                <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
                {badge > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 bg-terra text-cream text-[10px] font-bold rounded-full flex items-center justify-center px-1 leading-none">
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-medium ${active ? 'text-terra' : 'text-ink-muted'}`}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
